<template>
  <rabbey-base-drawer
    ref="rootTable"
    title="Lista de usuarios Navixy"
    size="85%"
    :drawer="drawer"
    v-on:update:drawer="$emit('update:drawer', $event)"
    v-loading.fullscreen.lock="fullscreenLoading"
    @open="getItems"
  >
    <cardDrawerHeaderUserNoContract :Data="items" />

    <FacturasVencidasGps
      :visible.sync="visible3"
      :Client="Client"
      @CloseFacturas="CloseDrawerFacturas"
    />

    <GpsDrawerNavixy
      :visible="gpsNavixyDetailDrawer"
      :Client="Client"
      @CloseGPSNavixy="CloseDrawerGPSNavixy"
    />

    <DrawerGPSNavision
      :visible="gpsNavisionDetailDrawer"
      :Client="Client"
      @CloseGPSNavision="CloseDrawerGPSNavision"
    />

    <el-row>
      <el-col>
        <el-select
          v-model="ClientModel"
          clearable
          filterable
          placeholder="Clientes"
          v-loading="loading"
          size="large"
          @change="HandlerSelecter"
        >
          <el-option
            v-for="(item, index) in listProspects"
            :key="index"
            :label="item.first_name + ' ' + item.last_name"
            :value="item.post_region"
          >
          </el-option>
        </el-select>
      </el-col>
    </el-row>

    <el-row>
      <el-col>
        <rabbey-table-3
          ref="table"
          :actions="actions"
          :loading="loading"
          :columns="columns"
          :data="items"
          :page_Size="300"
          :page-sizes="pageSize"
          show-summary
          :summary-method="getSummaries"
          @rtable-push-action="handlePushAction"
        ></rabbey-table-3>
      </el-col>
    </el-row>
    <rabbey-base-drawer
      :title="detailTitle"
      :drawer.sync="gpsDetailDrawer"
      size="80%"
      append-to-body
    >
      <el-row>
        <el-col>
          <rabbey-table-3
            ref="tableGpsDetail"
            :loading="loading2"
            :columns="columns2"
            :data="items2"
          ></rabbey-table-3>
        </el-col>
      </el-row>
    </rabbey-base-drawer>
  </rabbey-base-drawer>
</template>

<script>
import RenderCheck from "@/components/functionals/RenderCheck.vue";
import CellColorGps from "@/components/functionals/CellColorGps.vue";
import ElTagColorGps from "@/components/functionals/ElTagColorGps.vue";
import HyperLinkGps from "@/components/functionals/HyperLinkGps.vue";
import cardDrawerHeaderUserNoContract from "@/components/technical_support/drawerHeader/cardDrawerHeaderUserNoContract.vue";
import FacturasVencidasGps from "@/components/FacturasVencidasGps.vue";
import ElTagColorGpsContractos from "@/components/functionals/ElTagColorGpsContractos.vue";
import ElTagColorContracts from "@/components/functionals/ElTagColorContracts.vue";
import GpsDrawerNavixy from "./customers/GpsDrawerNavixy.vue";
import DrawerGPSNavision from "./customers/DrawerGPSNavision.vue";
import HyperLinkGpsEquipos from "@/components/functionals/HyperLinkGpsEquipos.vue";
import HyperLinkGpsNavisionEquipos from "@/components/functionals/HyperLinkGpsNavisionEquipos.vue";

export default {
  name: "NavixyUserNotContractList",
  components: {
    cardDrawerHeaderUserNoContract,
    FacturasVencidasGps,
    GpsDrawerNavixy,
    DrawerGPSNavision
  },
  props: {
    drawer: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      loading2: false,
      visible3: false,
      gpsNavixyDetailDrawer: false,
      gpsNavisionDetailDrawer: false,
      Client: "",
      pageSize: [300, 500, 1000],
      gpsDetailDrawer: false,
      indexUrl: "/api/navixy/GetReportUsersNotContract",
      items: [],
      items2: [],
      listProspects: [],
      ClientModel: "",
      tableHeight: 0,
      fullscreenLoading: false,
      columns: [
        {
          prop: "navixy_id",
          label: "No.",
          sortable: true,
          width: 120,
          fixed: true
        },
        {
          prop: "post_region",
          label: "Código (Region)",
          minWidth: 170,
          formatter: ElTagColorGpsContractos
        },
        { prop: "first_name", label: "Primer nombre", minWidth: 150 },
        { prop: "last_name", label: "Apellido", minWidth: 150 },
        {
          prop: "reason",
          label: "Razon",
          minWidth: 170,
          sortable: true,
          formatter: ElTagColorGps
        },
        {
          prop: "activated",
          label: "Activado",
          sortable: true,
          formatter: RenderCheck
        },
        {
          prop: "trackers_count",
          label: "Navixy",
          sortable: true,
          width: 130,
          formatter: HyperLinkGpsEquipos,
          attrs: {
            openDetailGPS: this.OpenDrawerGPSNavixy
          }
          // attrs: {
          //   openDetail: this.openDetail
          // },
          // formatter: ReportGPSHyperLink
        },
        {
          prop: "equiposNavixion",
          label: "Navision",
          sortable: true,
          width: 130,
          formatter: HyperLinkGpsNavisionEquipos,
          attrs: {
            openDetailGPSNavision: this.OpenDrawerGPSNavision
          }
        },
        {
          prop: "difference",
          label: "Diferencia",
          width: 130,
          sortable: true,
          formatter: CellColorGps
        },
        {
          prop: "FacturasVencidas",
          label: "Facturas Vencidas",
          width: 130,
          formatter: HyperLinkGps,
          sortable: true,
          attrs: {
            openDetail: this.OpenDrawerFacturas
          }
        },
        {
          prop: "TipoContrato",
          label: "Contrato",
          formatter: ElTagColorContracts,
          sortable: true,
          width: 130
        },
        { prop: "creation_date", label: "Fecha de creación", minWidth: 170 },
        { prop: "login", label: "Correo", minWidth: 260 },
        { prop: "phone", label: "Teléfono", minWidth: 140 },
        { prop: "post_city", label: "Postal", minWidth: 130 },
        { prop: "post_country", label: "País", minWidth: 200 },
        { prop: "verified", label: "Verificado/a", width: 130, sortable: true }
      ],
      columns2: [
        {
          prop: "navixy_id",
          label: "NO"
        },
        {
          prop: "model_name",
          label: "Modelo"
        },
        {
          prop: "label",
          label: "Titulo"
        },
        {
          prop: "clone",
          label: "Es Clone ?",
          formatter: RenderCheck
        },
        {
          prop: "user_id",
          label: "No Propietario"
        }
      ],
      actions: [
        { command: "view-trackers", label: "Ver Equipos", icon: "el-icon-view" }
      ],
      detailTitle: ""
    };
  },
  async created() {
    await this.getItems();
  },
  methods: {
    openDetail(row) {
      this.detailTitle = `${row.first_name} ${row.last_name} - GPS`;
      this.gpsDetailDrawer = true;
      this.loading2 = true;
      this.$http
        .get(`/api/navixy/TrackersByUser/${row.navixy_id}`)
        .then((resp) => {
          this.items2 = resp.data;
          this.loading2 = false;
        });
    },

    OpenDrawerFacturas(row) {
      this.Client = row.post_region;
      this.visible3 = true;
    },

    CloseDrawerFacturas(val) {
      this.visible3 = val;
    },

    OpenDrawerGPSNavixy(row) {
      this.Client = row.post_region;
      this.gpsNavixyDetailDrawer = true;
    },

    CloseDrawerGPSNavixy(val) {
      this.gpsNavixyDetailDrawer = val;
    },

    OpenDrawerGPSNavision(row) {
      this.Client = row.post_region;
      this.gpsNavisionDetailDrawer = true;
    },

    CloseDrawerGPSNavision(val) {
      this.gpsNavisionDetailDrawer = val;
    },

    async getItems() {
      this.loading = true;
      // this.$http
      //   .get(this.indexUrl, {
      //     timeout: 3 * 60 * 1000
      //   })
      //   .then((resp) => {
      //     this.items = resp.data;
      //     this.loading = false;
      //   });
      this.items = this.$store.getters["navixy/getUserList"];
      this.listProspects = this.items;
      await this.GetStatusContracs();
      this.loading = false;
    },

    async HandlerSelecter() {
      if (this.ClientModel) {
        this.items = this.$store.getters["navixy/getUserList"];
        this.loading = true;
        this.items = this.items.filter(
          (x) => x.post_region == this.ClientModel
        );
        await this.GetStatusContracs();
        this.loading = false;
      } else {
        await this.getItems();
      }
    },

    handlePushAction(action) {
      let self = this;
      const actions = {
        "view-trackers": (row) => {
          self.openDetail(row, "view-tracker");
        }
      };

      actions[action.command](action.row);
    },

    async GetStatusContracs() {
      let oldValues = [];
      let contratos = [];
      await this.$http
        .get(`/api/customers/GetContractLineClient`, {
          timeout: 3 * 60 * 3000
        })
        .then(({ data }) => {
          oldValues = [];
          contratos = data.Clientes;
        });

      this.items.forEach((element) => {
        let valor = contratos.find(
          (x) =>
            x.Cliente ==
            (element.post_region == ""
              ? element.navixy_id.trim()
              : element.post_region.trim())
        );
        if (valor) {
          let index = this.items.findIndex((x) =>
            x.post_region == ""
              ? x.navixy_id.trim()
              : x.post_region.trim() == valor.Cliente
          );
          if (this.items[index]) {
            element.navixy_id = valor.NumContrato;
            element.reason =
              valor.Status == 0 ? "Contrato Abierto" : "Contrato Cerrado";
            this.items[index].equiposNavixion = valor.Equipos;
            this.items[index].FacturasVencidas = valor.FacturasVencidas;
            this.items[index].TipoContrato = valor.TipoContrato;
            let diff = this.items[index];
            if (!diff.equiposNavixion) {
              this.items[index].difference = diff.trackers_count;
            } else {
              this.items[index].difference =
                diff.equiposNavixion - diff.trackers_count;
            }

            if (
              oldValues
                .map((item) => item.post_region)
                .includes(element.post_region)
            ) {
              this.items[index].color = "warning";
            } else {
              this.items[index].color = "success";
            }
            oldValues.push(element);
          }
        }
      });
    },

    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Total";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (column.property === "difference") {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return Math.abs(prev) + Math.abs(curr);
            } else {
              return prev;
            }
          }, 0);
        } else if (
          column.property === "trackers_count" ||
          column.property === "equiposNavixion"
        ) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
        } else {
          sums[index] = "";
        }
      });

      return sums;
    }
  }
};
</script>

<style>
.red-cell {
  color: red;
}
el-select {
  width: 200%;
}
</style>
